export const getNextTwelveMonths = () => {
    const months = []
    const date = new Date()
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

    for (let i = 0; i < 12; i++) {
        const year = date.getFullYear()
        const month = date.getMonth()
        const value = `${year}${(month + 1).toString().padStart(2, '0')}`
        const label = `${monthNames[month]} ${year}`
        months.push({ label, value })
        date.setMonth(month + 1)
    }

    return months
}